import { NavigationMockApi } from '@sprint-expert-manager/app/mock-api/common/navigation/api';
import { IconsMockApi } from '@sprint-expert-manager/app/mock-api/ui/icons/api';

export const mockApiServices = [IconsMockApi, NavigationMockApi];
